import { useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";

import "./Banner.css";

const Banner = ({ cmsLabels }) => {
  const { country, language } = useSelector((state) => state.langSettings);
  return (
    <>
      <div className="page-header">
        <div className="header-content">
          <div className="dds__container dds__pl-xl-0 dds__pl-4 ">
            <div className="dds__pt-5 header">
              <h2 className="dds__text-white">
                {cmsParser(cms.unsubscribe, cmsLabels)}
              </h2>
            </div>
            <div>
              <span
                className="dds__text-white"
                dangerouslySetInnerHTML={{
                  __html: cmsParser(cms.Header_Content, cmsLabels),
                }}
              ></span>{" "}
              <a
                className="dds__text-white dds__font-italic"
                target="_blank"
                rel="noopener noreferrer"
                href={`http://www.dell.com/preferences/?c=${country}&l=${language}`}
              >
                {cmsParser(cms.preference_management_center, cmsLabels)}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
